/**
 * Typeguard to checks `value` is _not_ `null` or `undefined`.
 *
 * @category Lang
 * @param value The value to check.
 * @returns Returns `true` and type narrows value to T if `value` is not nullish,
 * else `false` and no type narrowing.
 * @example
 *
 * isDefined(null: SomeType | null);
 * // => false, value: SomeType | null
 *
 * isDefined(undefined: SomeType | null | undefined);
 * // => false, value: SomeType | null | undefined
 *
 * isDefined(4: number | null | undefined);
 * // => true, value: number
 *
 * isDefined(0: number | null | undefined);
 * // => true, value: number
 *
 * isDefined('': string | null | undefined);
 * // => true, value: string
 *
 */
export const isDefined = <T>(value: T | undefined | null): value is T => {
  return value !== undefined && value !== null
}
